import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCareerAdd } from "../redux/careerAction"


const JobApplicationForm = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();

const {
  id: jobId, // 🔥 IMPORTANT
  title = "Job Title",
  location = "Location",
  type = "Job Type",
  qualification = "Qualification",
  requirements = [],
} = state || {};
  const [formData, setFormData] = useState({
    fullName: "",
    emailId: "",
    mobileNumber: "",
    coverLetter: "",
    agreedToTerms: false,
    awsm_form_privacy_policy: false,
  });

  const [errors, setErrors] = useState({});
  const [resumeFile, setResumeFile] = useState(null);
  const [responseMsg, setResponseMsg] = useState("");
  const [showModal, setShowModal] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = "Full Name is required";
    if (!formData.emailId) newErrors.emailId = "Email is required";
    if (!formData.mobileNumber) newErrors.mobileNumber = "Phone is required";
    if (!formData.coverLetter) newErrors.coverLetter = "Cover Letter is required";
    if (!resumeFile) newErrors.resume = "Resume is required";
    if (!formData.awsm_form_privacy_policy) newErrors.policy = "Please accept the policy";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    setResumeFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setShowModal(true);
  };

  const confirmSubmit = async () => {
    const payload = new FormData();
    payload.append("fullName", formData.fullName);
    payload.append("emailId", formData.emailId);
    payload.append("mobileNumber", formData.mobileNumber);
    payload.append("coverLetter", formData.coverLetter);
    payload.append("agreedToTerms", formData.agreedToTerms);
    payload.append("awsm_form_privacy_policy", formData.awsm_form_privacy_policy);
    payload.append("resume", resumeFile);
    payload.append("jobId", jobId);

    try {
      await dispatch(getCareerAdd(payload));
      setResponseMsg("Your application has been submitted successfully!");

      // Reset form
      setFormData({
        fullName: "",
        emailId: "",
        mobileNumber: "",
        coverLetter: "",
        agreedToTerms: false,
        awsm_form_privacy_policy: false,
      });
      setResumeFile(null);
      document.querySelector('input[name="resume"]').value = "";
      setErrors({});

      // Auto-clear message after 5 seconds
      setTimeout(() => {
        setResponseMsg("");
      }, 5000);
    } catch (err) {
      setResponseMsg("Submission failed. Please try again.");
    }

    setShowModal(false);
  };

  return (
    <div style={{ display: "flex", padding: "40px", gap: "40px", flexWrap: "wrap" }}>
      {/* LEFT SECTION */}
      <div style={{ flex: 1, padding: "40px", minWidth: "300px" }}>
        <h1 style={{ fontSize: "32px", fontWeight: "700" }}>{title}</h1>
        <p>🎓 {qualification}</p>
        <p>📍 {location}</p>
        <p>🕒 {type}</p>

        <h3 style={{ fontWeight: "700", marginTop: "20px" }}>Requirements:</h3>
        <ul style={{ padding: 0, marginTop: "10px" }}>
          {requirements.map((item, index) => (
            <li key={index} style={reqItem}>✅ {item}</li>
          ))}
        </ul>
      </div>

      {/* RIGHT SECTION: FORM */}
      <div style={formCard}>
        <h2 style={{ marginBottom: "20px" }}>Apply for this position</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name *"
            value={formData.fullName}
            onChange={handleChange}
            style={inputStyle}
          />
          {errors.fullName && <p style={errorStyle}>{errors.fullName}</p>}

          <input
            type="email"
            name="emailId"
            placeholder="Email *"
            value={formData.emailId}
            onChange={handleChange}
            style={inputStyle}
          />
          {errors.emailId && <p style={errorStyle}>{errors.emailId}</p>}

          <input
            type="text"
            name="mobileNumber"
            placeholder="Phone *"
            value={formData.mobileNumber}
            onChange={handleChange}
            style={inputStyle}
          />
          {errors.mobileNumber && <p style={errorStyle}>{errors.mobileNumber}</p>}

          <textarea
            name="coverLetter"
            placeholder="Cover Letter"
            value={formData.coverLetter}
            onChange={handleChange}
            rows="4"
            style={inputStyle}
          />
          {errors.coverLetter && <p style={errorStyle}>{errors.coverLetter}</p>}

         <label style={{ fontWeight: "600", display: "block", marginBottom: "6px" }}>
  Upload Resume *
</label>
<input
  type="file"
  name="resume"
  onChange={handleFileChange}
  required
  style={{ marginBottom: "18px" }}
/>
{errors.resume && <p style={errorStyle}>{errors.resume}</p>}


          <div style={{ marginBottom: "12px" }}>
            <label>
              <input
                type="checkbox"
                name="awsm_form_privacy_policy"
                checked={formData.awsm_form_privacy_policy}
                onChange={handleChange}
              />{" "}
              I agree to the terms and privacy policy.
            </label>
            {errors.policy && <p style={errorStyle}>{errors.policy}</p>}
          </div>

          <button type="submit" style={submitBtn}>Submit Application →</button>

          {responseMsg && (
            <p style={{ marginTop: "16px", fontWeight: "600", color: "green" }}>
              {responseMsg}
            </p>
          )}
        </form>
      </div>

      {/* CONFIRMATION MODAL */}
      {showModal && (
        <div style={modalOverlay}>
          <div style={modalBox}>
            <h3>Confirm Submission</h3>
            <p>Are you sure you want to submit the application?</p>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button onClick={() => setShowModal(false)} style={cancelBtn}>Cancel</button>
              <button onClick={confirmSubmit} style={submitBtn}>Submit</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const formCard = {
  flex: 1,
  background: "#fff",
  padding: "32px",
  borderRadius: "12px",
  boxShadow: "0 0 20px rgba(0,0,0,0.1)",
  minWidth: "300px",
};

const reqItem = {
  marginBottom: "12px",
  padding: "12px 16px",
  background: "#f9f9f9",
  borderRadius: "8px",
  fontSize: "15px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "14px",
};

const errorStyle = {
  color: "red",
  fontSize: "13px",
  // marginBottom: "2px",

};

const modalOverlay = {
  position: "fixed",
  top: 0, left: 0,
  width: "100%", height: "100%",
  background: "rgba(0,0,0,0.3)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalBox = {
  background: "#fff",
  padding: "24px",
  borderRadius: "10px",
  width: "400px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
};

const submitBtn = {
  backgroundColor: "#3d68f8",
  color: "#fff",
  padding: "10px 18px",
  borderRadius: "6px",
  border: "none",
  cursor: "pointer",
};

const cancelBtn = {
  backgroundColor: "#ddd",
  color: "#000",
  padding: "10px 18px",
  borderRadius: "6px",
  border: "none",
  cursor: "pointer",
};

export default JobApplicationForm;
